import { render, staticRenderFns } from "./transferList.vue?vue&type=template&id=db4daa68"
import script from "./transferList.vue?vue&type=script&lang=js"
export * from "./transferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports